/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/display-name */
/**
 *
 * PrivateRoute
 *
 */

import React, { memo, useEffect } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from '@mui/material';
import {
  makeSelectLoggedInState,
  selectCaslAbility,
} from '../../managers/AuthManager/selectors';
import SplashScreen from '../SplashScreen';
import {
  getCurrentUserAction,
  resetAuthStateAction,
} from '../../managers/AuthManager/actions';
import { Header } from '../Header';
import { resetLogin } from '../../managers/LoginManager/actions';
import UserPreferencesManager from '../../managers/UserPreferencesManager';
import { AbilityContext } from '../../casl/AbilityContext';
import { ability } from '../../casl/ability';

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

export function PrivateRoute() {
  // load current user
  const loggedInState = useSelector(makeSelectLoggedInState());
  const abilityRules = useSelector(selectCaslAbility);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Update ability rules when they change
    ability.update(abilityRules);
  }, [abilityRules]);
  useEffect(() => {
    dispatch(getCurrentUserAction());
    return () => {
      dispatch(resetAuthStateAction());
      dispatch(resetLogin());
    };
  }, [dispatch]);

  const isSessionDialogOpen = loggedInState === 'expired';

  const navigateOnSessionDialogClose = () => {
    dispatch(resetAuthStateAction());
    dispatch(resetLogin());
    navigate('login');
  };

  // if current user api call status is 2 and islogged in false, then show the session expired dialog
  if (loggedInState === 'failed' || loggedInState === 'logout') {
    return <Navigate to="/login" state={{ from: location }}></Navigate>;
  }
  if (loggedInState === 'alive' || loggedInState === 'expired') {
    return (
      <AbilityContext.Provider value={ability}>
        <Header />
        <Container
          maxWidth={false}
          sx={{
            mt: 2,
            backgroundColor: '#F4F4F4',
            maxWidth: '100vw',
          }}
        >
          <UserPreferencesManager>
            <Outlet />
          </UserPreferencesManager>
          {/* </StrictMode> */}
        </Container>
        <Dialog
          open={isSessionDialogOpen}
          TransitionComponent={Transition}
          keepMounted
          onClose={navigateOnSessionDialogClose}
          aria-describedby="session-expired-title"
        >
          <DialogTitle>Session expired</DialogTitle>
          <DialogContent>
            <DialogContentText id="session-expired-title">
              Your session has been expired. Please login again.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={navigateOnSessionDialogClose}>Login</Button>
          </DialogActions>
        </Dialog>
      </AbilityContext.Provider>
    );
  }

  return <SplashScreen />;
}

export default memo(PrivateRoute);
